import React from 'react';
import RawHTML from '~/components/jsx-helpers/raw-html';
import { Countdown, Amount, GiveButton } from './common';
import './content-mobile.scss';
function HeadlineImage({ headline, image }) {
    return (React.createElement("div", { className: "headline-image", style: { backgroundImage: `url(${image})` } },
        React.createElement("div", { className: "gradient" }),
        React.createElement(RawHTML, { Tag: "h1", html: headline })));
}
function MessageBox({ buttonText, buttonUrl, headline, html, message }) {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "blue-section" },
            React.createElement(GiveButton, { text: buttonText, url: buttonUrl }),
            React.createElement("h2", null,
                headline,
                " "),
            React.createElement(RawHTML, { html: html })),
        React.createElement("div", { className: "white-section" }, message)));
}
function GoalBox({ buttonText, buttonUrl, goalAmount, goalTime, message }) {
    return (React.createElement("div", { className: "goal-info" },
        React.createElement(GiveButton, { text: buttonText, url: buttonUrl }),
        React.createElement(Countdown, { goalTime: goalTime }),
        React.createElement(Amount, { amount: goalAmount }),
        React.createElement("div", { className: "white-section" }, message)));
}
function Box({ data }) {
    return ({
        message: (React.createElement(MessageBox, { buttonText: data.buttonText, buttonUrl: data.buttonUrl, headline: data.boxHeadline, html: data.boxHtml, message: data.message })),
        goal: (React.createElement(GoalBox, { buttonText: data.buttonText, buttonUrl: data.buttonUrl, goalAmount: data.goalAmount, goalTime: data.goalTime, message: data.message }))
    }[data.messageType] || React.createElement("h1", null,
        "OOPS, ",
        data.messageType));
}
export default function MobileContent({ data }) {
    React.useEffect(() => {
        var _a;
        (_a = document.getElementById('header')) === null || _a === void 0 ? void 0 : _a.classList.add('over-mobile-dialog');
        return () => {
            var _a;
            (_a = document
                .getElementById('header')) === null || _a === void 0 ? void 0 : _a.classList.remove('over-mobile-dialog');
        };
    }, []);
    return (React.createElement("div", { className: "takeover-content mobile-only" },
        React.createElement(HeadlineImage, { headline: data.headline, image: data.image }),
        React.createElement(Box, { data: data })));
}
